import React, { FC, useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import SuggestionForm from '../../ui/SuggestionForm/SuggestionForm';
import { Alert } from 'react-bootstrap';
import ProxioSuggestionForm from '../../ui/ProxioSuggestionForm/ProxioSuggestionForm';

import { Props } from '../../../App';
import { useSearchParams } from 'react-router-dom';

interface ISearchParams {
    inventaryId: string | null,
    category: string | null,
    value: string | null,
    utm_source: string | null,
    utm_medium: string | null,
    utm_campaign: string | null,
}

interface SProps extends Props {
  id: number;
}

const Suggestion: FC<SProps> = (props): JSX.Element => {
  const [show, setShow] = useState(true);
  const [searchParams] = useSearchParams();
  const params = useMemo(() => Object.fromEntries(searchParams.entries()), [searchParams]);

  const {
    inventaryId  = null,
    category     = null,
    value        = null,
    utm_source   = null,
    utm_medium   = null,
    utm_campaign = null,
  } = params as Record<string, string | null>;

  const searchParamsObject: ISearchParams = {
    inventaryId,
    category,
    value,
    utm_source,
    utm_medium,
    utm_campaign,
  };

  return (
    <section className="top">
      <Container fluid="md">
        {show && (
          <Alert className='text-center' variant='warning' onClose={() => setShow(false)} dismissible>
            Tato služba slouží pouze k hlášení běžných poruch a podnětů, nikoliv pro hlášení havarijních situací. V případě nouze volejte 112.
          </Alert>
        )}
        <h1 className="px-3 mb-5 display-3 text-center">{props.header}</h1>
        {inventaryId ?
          <ProxioSuggestionForm id={props.id} searchParams={searchParamsObject}/>
        :
          <SuggestionForm id={props.id} />
        }
      </Container>
    </section>
  );
};

export default Suggestion;
